import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./cp-location-summary-directive.html';
import styles from './LocationSummary-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        require: 'gwCpPremisesSummary',
        scope: {
            location: '=',
            edit: '&?',
            change: '&',
            showChooseDifferentLocation: '=',
            flavor: '@',
            buildingId: '@?'
        },
        transclude: true,
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', 'InsuranceSuiteMetadata', '$state', function ($scope, insuranceSuiteMetadata, $state) {

            var typelist = insuranceSuiteMetadata.get('pc').types.getTypelist('FireProtectClass');
            $scope.location.displayAddress = $scope.location.displayName.split(',');
            $scope.fireProtection = $scope.location.fireProtection ? typelist.getCode($scope.location.fireProtection).name : null;

            if (!$scope.edit) {
                $scope.edit = function () {
                    $state.go('cpBuildingWizardEditLocation', { publicID: $scope.location.publicID, buildingPublicID: $scope.buildingId });
                };
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/directives/cp-premises-summary-directive/cp-location-summary-directive/CPLocationSummaryDirective.js
// module id = 999
// module chunks = 0